var user = {
    list: function(page){
        var params = utils.getParamObj();
        params.like = $("#sm3").val();
        params.page = page || 1;
        var getParams = location.pathname+"?"+($.param(params));
        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);
            $.get(getParams,params,function(resp){
                $("#user_list").html(resp)
            });
        }else{
            location.href=getParams;
        }
    },
    permissionlist: function(page){
        var params = utils.getParamObj();
        params.moduleID = $("#select-module option:selected").val();
        params.page = page || 1;
        var getParams = location.pathname+"?"+($.param(params));
        $("#add-new-perm").attr('href','/admin/users/permission/'+(params.moduleID > 0?params.moduleID:''));
        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);
            $.get(getParams,params,function(resp){
                $("#permission_list").html(resp)
            });
        }else{
            location.href=getParams;
        }
    },
    grouplist: function(page){
        var params = utils.getParamObj();
        params.moduleID = $("#select-module option:selected").val();
        params.page = page || 1;
        var getParams = location.pathname+"?"+($.param(params));
        $("#add-new-group").attr('href','/admin/users/group/'+(params.moduleID > 0?params.moduleID:''));
        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);
            $.get(getParams,params,function(resp){
                $("#group_list").html(resp)
            });
        }else{
            location.href=getParams;
        }
    },
    savePermission: function(moduleID){
        var params = $("#modal-form :input").serializeObj();
        params.moduleID = moduleID || $("#select-module option:selected").val();
        // params._token = utils.getToken();
        $.post('/admin/users/savePermission',params,function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
    saveGroup: function(moduleID){
        var params = $("#modal-form :input").serializeObj();
        params.moduleID = moduleID || $("#select-module option:selected").val();
        // params._token = utils.getToken();
        params.users = {};
        params.permissions = {};
        params.countries = {};

        $("#selected_users .tm-tag").each(function(){
            params.users[$(this).find('a').attr('tagidtoremove')] = $(this).find('a').attr('tagidtoremove');
        });
        $("#selected_permissions .tm-tag").each(function(){
            params.permissions[$(this).find('a').attr('tagidtoremove')] = $(this).find('a').attr('tagidtoremove');
        });
        $("#selected_countries .tm-tag").each(function(){
            params.countries[$(this).find('a').attr('tagidtoremove')] = $(this).find('a').attr('tagidtoremove');
        });
        $.post('/admin/users/saveGroup',params,function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
    groupState: function(groupID, state){
        $.post('/admin/users/groupState/'+groupID+'/'+state,{/*'_token':utils.getToken()*/},function(resp){
            location.reload();
        });
    },
    save: function (userID){
        //var params = $("form#user").serialize();
        //params+='&_token='+utils.getToken();
        //params+='&userID='+userID;
        var params = $("form#user #tab1_1 :input").serializeObj(false);
        params.userID = userID || 0;
        // params._token = utils.getToken();


        $.post('/admin/users/save',params,function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
    state: function(userID, state){
        $.post('/admin/users/state/'+userID+'/'+state,{/*'_token':utils.getToken()*/},function(resp){
            location.reload();
        });
    },
    saveUserSettings: function(moduleID, name, value, paramID){
        var params = utils.getParamObj();
        // params._token = utils.getToken();
        params.name = name;
        params.value = value;
        params.paramID = paramID;
        params.paramName = $("#"+moduleID+"_"+name).val();
        $.post('/admin/users/saveUserSettings/'+moduleID,params,function(resp){
            //location.reload();
        });
    },

    deleteUser: function(userID) {
        $.post('/admin/Users/deleteUser/' + userID, function(resp){
            console.debug('Kész a törlés: ' + resp);
        })
    },
};